import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service';
import { VerMapaPage } from '../../pages/vermapa/vermapa';
import { CadastroPage } from '../cadastro/cadastro';

declare var gtag;

@Component({
	selector: 'login',
  	templateUrl: 'login.html',
})

export class LoginPage {
	loading: Loading;
	registerCredentials = { email: '', password: '' };

	public cadastroPage = CadastroPage;
 
	  constructor(private navCtrl: NavController, 
				  private auth: AuthService, private alertCtrl: AlertController, 
				  private loadingCtrl: LoadingController) {}
 
	public login() {
    	this.showLoading();
    	this.auth.login(this.registerCredentials).subscribe(allowed => {
		 	if (allowed) {
				gtag('event', 'login');
				this.navCtrl.push(VerMapaPage);
		 	} else {
		        this.showError("Por favor, tente novamente.");
			}
		},
	   error => {
	  		this.showError(error);
		});
	}
 
  	showLoading() {
    	this.loading = this.loadingCtrl.create({
      		content: 'Carregando...',
      		dismissOnPageChange: true
    	});
    	
    	this.loading.present();
  	}
 
  	showError(text) {
    	this.loading.dismiss();
 
	    let alert = this.alertCtrl.create({
	    	title: 'Dados incorretos',
	      	subTitle: text,
	      	buttons: ['OK']
	    });
	    
	    alert.present(alert);
	}
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts